import {Component, Prop, Vue} from 'vue-property-decorator';
import {IUserTask} from '@/shared/api-client/models/user-task/user-task';
import {IUserTaskPropertyBagValue} from '@/shared/api-client/enums/user-task-property-bag-value';

@Component
export default class UserTaskBadgeComponent extends Vue {

    @Prop() public userTask!: IUserTask;
    @Prop() public translations!: { [key: string]: string; };

    public getStatus(userTask: IUserTask): IUserTaskPropertyBagValue {

        if (userTask.entityType === 'ActivityMeeting' || userTask.entityType === 'ActivityMotion') {
            return userTask.propertyBag && userTask.propertyBag.activityStatus;
        }

        if (userTask.entityType === 'Election') {
            return userTask.propertyBag && userTask.propertyBag.electionState;
        }

        throw new Error(`Invalid status`);
    }
}
